// extracted by mini-css-extract-plugin
export default {"checkoutFriendRedemption":"_9ee6b808"};